import Component from "../abstracts/Component";

export default class ProductPageLogic extends Component {
  
  get SELECTORS() {
    return {
      main: '.js-addtocart'
    }
  }

  constructor() {
    super();
  }

  bindEvents() {
    let elem = document.querySelector('.jsToBagBtn');
    if(elem != null) {
      const sku = document.querySelector('.jsToBagBtn').dataset.productCode
      this
        .$doAjax({
          type: 'POST',
          url: '/action/ajax/specialpdpcheck',
          data: {
            sku: sku
          }
        })
        .done(resp => {
          if(resp) {
            this
              .$doAjax({
                type: 'POST',
                url: '/action/ajax/specialpdp',
                data: {
                  sku: sku
                }
              })
              .done(resp => {
                $('.js-editorial-content').append($(resp).find('#pdp-editorial'));
                this.$emit(this.$customEvents.CAROUSEL.triggerCarousel);
              })
              .fail(xhr => {
                this.log('Related page not found');
              })
              .always((xhr) => {
                
              });
          }
        })
        .fail(xhr => {
          this.log('Related page not found');
        })
        .always((xhr) => {
          
        });
    }
  }

  render() {
    this.log('Rendering...');
    this.bindEvents();
  }

}